<style lang="scss" scoped>
.page-customer-detail {
  display: flex;
  .flex7 {
    flex: 7;
  }
  .flex3 {
    flex: 3;
    margin: 0 10px;
  }
  .detail-block {
    margin-bottom: 10px;
    @include border-shadow();
    border-radius: 6px;
    padding: 20px;
    background: #fff;
    .block-top {
      border-bottom: 1px solid $color-border-gray-light;
      display: flex;
    }
    .hd {
      border-bottom: 1px solid $color-border-gray-light;
      margin-bottom: 20px;
      font-weight: 600;
      padding-bottom: 4px;
    }
    .bd {
      // display: flex;
      // border-bottom: 1px solid $color-border-gray-light;
      padding-bottom: 20px;
    }
    .icon-wrap {
      width: 100px;
      height: 100px;
      border-radius: 6px;
      overflow: hidden;
      margin-right: 10px;
    }
    .customer-info {
      width: 100%;
      margin: 20px 0 0 10px;
      .name {
        font-size: 14px;
        color: #333;
        font-weight: 600;
      }
      .alias {
        font-size: 13px;
      }
      &-hd {
        display: flex;
        margin-bottom: 10px;
        .guide-member {
          color: #409eff;
          border: #409eff 1px solid;
          border-radius: 3px;
          text-align: center;
          padding: 4px;
          margin-top: -6px;
          margin-left: 10px;
          font-size: 14px;
          font-style: none;
        }
      }
      .label-box {
        display: flex;
        .label {
          margin-right: 40px;
          min-width: 160px;
        }
      }
    }
    .price {
      font-size: 24px;
    }
  }

  .guide-info {
    // @include border-shadow();
    border-radius: 6px;
    padding: 20px;
    margin: 20px 0;
    background: #fff;
    .hd {
      display: flex;
      .left-grid {
        flex: 1;
      }
      .right-grid {
        flex: 1;
      }
      .g-hd {
        font-weight: 600;
        margin-bottom: 4px;
      }
    }
    .guide-list {
      width: calc(100% - 20px);
      .avatar-wrap {
        display: flex;
      }
      .avatar-icon {
        margin-right: 10px;
        img {
          width: 36px;
          display: block;
        }
      }
      .avatar-info {
        line-height: 18px;
        .name {
        }
        .mobile {
        }
      }
    }
    .baseinfo-table {
      width: 100%;
      tr {
        &:first-child {
          td {
            // border-top: 1px solid $color-border-gray-light;
          }
        }
        td {
          border-right: 1px solid $color-border-gray-light;
          border-bottom: 1px solid $color-border-gray-light;
          padding: 4px 10px;
          font-size: 13px;
          height: 36px;
          min-width: 100px;
          &:first-child {
            border-left: 1px solid $color-border-gray-light;
          }
        }
      }
      .label {
        background: #f2f2f2;
        width: 50px;
        text-align: center;
      }
    }
    .customer-order {
      .hd {
        display: flex;
        align-items: center;
        height: 60px;
        .hd-item {
          margin: 0 30px;
          font-weight: 600;
        }
      }
    }
    .likebuy-list {
      .hd {
        display: flex;
        align-items: center;
        height: 60px;
        .tip {
          margin-left: 10px;
        }
      }
    }
    .customer-footrecode {
      .hd {
        display: flex;
        align-items: center;
        height: 60px;
      }
    }
    .tip {
      font-size: 13px;
    }
    .member-info {
      &-line {
        display: flex;
        margin-bottom: 20px;
        .label {
          margin-right: 40px;
          min-width: 160px;
        }
      }
    }
  }

  .buy-list {
    width: 100%;
  }
  .sp-table-grid {
    .avatar-wrap {
      display: flex;
      .avatar-icon {
        margin-right: 10px;
        width: 60px;
        height: 60px;
        display: flex;
        align-items: center;
        img {
          width: 60px;
          height: 60px;
          display: block;
        }
      }
      .avatar-info {
        .name {
        }
        .mobile {
        }
      }
    }
  }
}
</style>
<style lang="scss">
.page-customer-detail {
  .el-table--border {
    border: none !important;
  }
  .el-table th.is-leaf,
  .el-table td {
    border-right: none !important;
  }
  .el-table::before,
  .el-table--group::after,
  .el-table--border::after {
    display: none !important;
  }
  .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    display: none !important;
  }
  .el-table__empty-block {
    border: none !important;
  }
}
</style>
<template>
  <div class="page-customer-detail">
    <div class="flex7">
      <div class="detail-block">
        <!-- <div class="hd">
        {{ `客户详情（已关联${guideList ? guideList.length : 0}个导购）` }}
      </div> -->
        <div class="block-top">
          <div class="icon-wrap">
            <img
              :src="(customerInfo && customerInfo.avatar) || require('@/assets/img/mallgoods.jpg')"
              alt=""
              width="100%"
            >
          </div>
          <div
            v-if="customerInfo"
            class="customer-info"
          >
            <div class="customer-info-hd">
              <div class="name">
                {{ customerInfo.nickname }}
              </div>
              <div
                v-if="customerInfo.bind_salesperson_name"
                class="guide-member"
              >
                专属导购：{{ customerInfo.bind_salesperson_name }}
              </div>
            </div>
            <div class="label-box">
              <div class="label">
                添加时间：{{ customerInfo.created_at }}
              </div>
              <div class="label">
                添加渠道：{{ customerInfo.channel_name }}
              </div>
              <!-- <div class="label">
                客户状态：
              </div> -->
            </div>
          </div>
        </div>
        <div
          v-if="customerInfo"
          class="guide-info"
        >
          <div class="g-bd">
            <div class="member-info">
              <div class="member-info-line">
                <div class="label">
                  手机 : <span>{{ customerInfo.mobile }}</span>
                </div>
                <!-- <div class="label">
                  出生日期 : <span>{{ customerInfo.age }}</span> 
                </div> -->
                <div class="label">
                  unionID : <span>{{ customerInfo.unionid }}</span>
                </div>
              </div>
              <div class="member-info-line">
                <div class="label">
                  性别 : <span>{{ handleFormatSex(customerInfo.sex) }}</span>
                </div>

                <span class="label"> 备注 : </span>
                <span colspan="3">
                  {{ customerInfo.description }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="detail-block">
        <div class="hd">
          会员信息
        </div>
        <div style="display: flex">
          <div
            class="hd-item"
            style="margin-right: 40px"
          >
            消费金额（元）
            <div class="price">
              {{ orderFree }}
            </div>
          </div>
          <div class="hd-item">
            消费订单数
            <div class="price">
              {{ orderCount }}
            </div>
          </div>
        </div>
        <el-tabs
          v-model="tabActive"
          @tab-click="handleClickTab"
        >
          <el-tab-pane
            label="客户订单"
            name="tab1"
          >
            <div class="customer-order">
              <SpTableGrid
                ref="orderTableGrid"
                :columns="columnsOrder"
                :on-page-change="onPageChangeOrder"
              />
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="常购清单"
            name="tab2"
          >
            <div class="likebuy-list">
              <div>
                <el-select
                  v-model="timeRange"
                  size="small"
                  placeholder="请选择"
                  style="margin-right: 20px"
                  @change="onChangeTimeRange"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <span class="tip">仅显示前10件商品</span>
              </div>
              <SpTableGrid
                ref="goodsTableGrid"
                nopagination
                :columns="columnsGoods"
                :on-page-change="onPageChangeGoods"
              />
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="客户足迹"
            name="tab3"
          >
            <div class="customer-footrecode">
              <div>
                <span class="tip">仅显示前100件商品</span>
              </div>
              <div class="bd">
                <SpTableGrid
                  :columns="columnsFoot"
                  :on-page-change="onPageChangeFoot"
                />
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="flex3">
      <BabelEdit
        v-if="customerInfo"
        :unionid="customerInfo.unionid"
      />
    </div>
  </div>
</template>

<script>
// import SpGuideBox from '@/components/guideBox'
import { formatSex } from '@/utils'
import moment from 'moment'
import { CUSTOMER_ORDER_STATUS } from '@/consts'
import BabelEdit from './comps/babelEdit.vue'
export default {
  components: {
    // SpGuideBox
    BabelEdit
  },
  data () {
    return {
      tabActive: 'tab1',
      options: [
        { value: 0, label: '一年内' },
        { value: 1, label: '半年内' },
        { value: 2, label: '三个月内' }
      ],
      timeRange: 0,
      customerInfo: null,
      guideList: [],
      goodsList: [],
      orderFree: 0,
      orderCount: 0,
      orderAvg: 0,
      showBox: false,
      columnsOrder: [
        {
          key: '',
          type: 'expand',
          render: (h, { row }) => {
            return (
              <div style={{ 'display': row.items ? 'block' : 'none' }} class='avatar-wrap'>
                <div class='avatar-info'>
                  {(row.items.length &&
                    row.items.map((good) => {
                      return (
                        <div style='display:flex;'>
                          <div class='avatar-icon'>
                            <img src={good.pic} />
                          </div>
                          <div>
                            <div>
                              商品名称 :<span>{good.item_name}</span>
                            </div>
                            <div>
                              商品金额 :<span>{good.item_fee}</span>
                            </div>
                            <div>
                              商品数量 :<span>{good.num}</span>
                            </div>
                          </div>
                        </div>
                      )
                    })) ||
                    '无商品数据'}
                </div>
              </div>
            )
          }
        },
        { name: '订单信息', key: 'order_id' },
        { name: '商品数量', key: 'buy_num' },
        {
          name: '订单状态',
          key: 'order_status',
          formatter: (row, column) => {
            return CUSTOMER_ORDER_STATUS[row.order_status]
          }
        },
        {
          name: '日期',
          key: 'create_time',
          formatter: (row, column) => {
            return row.pay_time
          }
        },
        { name: '实付金额', key: 'total_fee' }
      ],
      columnsGoods: [
        {
          name: '商品信息',
          key: 'item_name',
          render: (h, { row }) => {
            return (
              <div class='avatar-wrap'>
                <div class='avatar-icon'>
                  <img src={row.pic} />
                </div>
                <div class='avatar-info'>
                  <div class='name'>{row.item_name}</div>
                </div>
              </div>
            )
          }
        },
        {
          name: '商品价格',
          key: 'price'
        },
        { name: '购买次数', key: 'sales_num' }
      ],
      columnsFoot: [
        {
          name: '商品信息',
          key: 'item_name',
          render: (h, { row }) => {
            return (
              <div class='avatar-wrap'>
                <div class='avatar-icon'>
                  <img src={row.itemData.pics[0]} />
                </div>
                <div class='avatar-info'>
                  <div class='name'>{row.itemData.item_name}</div>
                </div>
              </div>
            )
          }
        },
        {
          name: '商品价格',
          key: 'price',
          formatter: (row, column) => {
            return `${row.itemData.price}`
          }
        },
        {
          name: '最后浏览时间',
          key: 'updated',
          formatter: (row, column) => {
            return moment(row.updated * 1000).format('YYYY-MM-DD HH:mm:ss')
          }
        }
      ]
    }
  },
  mounted () {
    this.getCustomerDetail()
    // this.getGuideByCustomer()
  },
  methods: {
    // 用户详情
    async getCustomerDetail () {
      const { id } = this.$route.params
      const res = await this.$api.salesperson.getCustomerDetail({
        memberId: id
      })
      this.customerInfo = res
    },
    // 导购列表
    async getGuideByCustomer () {
      const { id } = this.$route.params
      const res = await this.$api.salesperson.getGuideByCustomer({
        memberId: id
      })
      this.guideList = res
    },
    onChangeTimeRange () {
      this.$refs.goodsTableGrid.fetch()
    },
    // tab切换
    handleClickTab (e) {
      console.log(`handleClickTab:`, e, this.tabActive)
    },
    handleFormatSex (sex) {
      return formatSex(sex)
    },
    // 客户订单
    async onPageChangeOrder (params) {
      const { page, pageSize } = params
      const { id } = this.$route.params
      let query = {
        page,
        page_size: pageSize,
        pageSize,
        memberId: id
      }
      const { total_count, total_amount, avg_amount, list } =
        await this.$api.salesperson.getMemberOrder(query)
      this.orderFree = total_amount
      this.orderCount = total_count
      this.orderAvg = avg_amount
      console.log('onCurrentChange', total_count)
      return {
        list,
        total_count: parseInt(total_count)
      }
    },
    // 常购清单
    async onPageChangeGoods () {
      const { id } = this.$route.params
      const { list } = await this.$api.salesperson.getBuyGoodsList({
        memberId: id,
        timeRange: this.timeRange
      })
      return {
        list
      }
    },
    // 客户足迹
    async onPageChangeFoot (params) {
      const { page, pageSize } = params
      const { id } = this.$route.params
      let query = {
        page,
        page_size: pageSize,
        pageSize,
        memberId: id
      }
      const { total_count, list } = await this.$api.salesperson.getFootPrint(query)
      return {
        list,
        total_count
      }
    }
  }
}
</script>
